/**
 * A list of focusable elements for use in `document.querySelector` and `document.querySelectorAll`
 */
export const focusableElements = 'button, [href], input, select, textarea, [tabindex]';
